/* global $, prestashop */
/**
 * 2007-2023 A3WEB
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/OSL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * @author    A3WEB
 * @copyright 2013-2023 A3WEB <https://www.a3web.fr>
 * @license   https://opensource.org/licenses/OSL-3.0 Open Software License (OSL 3.0)
 *
 */

$(document).ready(() => {
    const Cookies = require('js-cookie');
    

    function init(){
        let userChoice = Cookies.get('user_choice'); 
        var choicelist= document.getElementById('Listview_product');
        var choicethumb= document.getElementById('Thumbnailview_product');
        var productlist= document.getElementById('js-product-list');

        choicethumb.classList.toggle('active', userChoice === undefined);
        productlist.classList.toggle('product_show_list', userChoice !== undefined);
        choicelist.classList.toggle('active', userChoice !== undefined);
   }    

    init();

    prestashop.on('updateProductList', () => { init()})
    
    $(document).on('click', '#Listview_product, #Thumbnailview_product', (event) => {
        switchView(event.target.id);
    });

    function switchView(view){
        let isThumbnailView = view === 'Thumbnailview_product';
        var choicelist= document.getElementById('Listview_product');
        var choicethumb= document.getElementById('Thumbnailview_product');
        var productlist= document.getElementById('js-product-list'); 

        choicethumb.classList.toggle('active', isThumbnailView);
        choicelist.classList.toggle('active', !isThumbnailView);
        productlist.classList.toggle('product_show_list', !isThumbnailView);

        if(view == "Thumbnailview_product"){
           

            Cookies.remove('user_choice', { path: '' })

        }else{

            Cookies.set('user_choice', 'list', { expires: 365, path: '' });
        }

    }
});